export enum PlanTier {
  free = 1,
  premium,
  starter,
  business,
}
